export const STATES = {
  INIT: 'INIT',

  LOADING: 'LOADING',

  RSA: 'RSA',
  NEEDS_RSA: 'NEEDS_RSA',
  RSA_LOADING: 'RSA_LOADING',
  RSA_DONE: 'RSA_DONE',

  IMAGES: 'IMAGES',
  NEEDS_IMAGES: 'NEEDS_IMAGES',
  IMAGES_LOADING: 'IMAGES_LOADING',
  IMAGES_DONE: 'IMAGES_DONE',

  TEXT_ADS: 'TEXT_ADS',
  NEEDS_TEXT_ADS: 'NEEDS_TEXT_ADS',
  TEXT_ADS_LOADING: 'TEXT_ADS_LOADING',
  TEXT_ADS_DONE: 'TEXT_ADS_DONE',

  IMAGE_ADS: 'IMAGE_ADS',
  NEEDS_IMAGE_ADS: 'NEEDS_IMAGE_ADS',
  IMAGE_ADS_LOADING: 'IMAGE_ADS_LOADING',
  IMAGE_ADS_DONE: 'IMAGE_ADS_DONE',

  BUDGET: 'BUDGET',
  NEEDS_TARGETS: 'NEEDS_TARGETS',
  TARGETS_LOADING: 'TARGETS_LOADING',
  NEEDS_KEYWORDS: 'NEEDS_KEYWORDS',
  KEYWORDS_LOADING: 'KEYWORDS_LOADING',
  BUDGET_LOADING: 'BUDGET_LOADING',
  BUDGET_DONE: 'BUDGET_DONE',

  BI: 'BI',
  BI_LOADING: 'BI_LOADING',
  BI_DONE: 'BI_DONE',

  DONE: 'DONE',
};
